import bugsnagClient from '../global/bugsnag';
import Vue from 'vue';
import VueMq from 'vue-mq';
import { createApp } from './index';
require('../../less/pdp-new.less');

Vue.use(VueMq, {
	breakpoints: {
		"pdp-mobile": 601,
		"mobile": 767,
		"tablet": 1024,
		"desktop": Infinity
	}
});

/* Start it up
============================================*/
(function() {
	const storeData = window.productjson;
	if (window.publicPath) __webpack_public_path__ = window.publicPath;

	if (window.location.pathname.startsWith('/reviews')) {
		return;
	}

	if (!storeData) {
		bugsnagClient.notify(new Error('window.productjson was undefined on new PDP'));
		return;
	}

	const { app, bottomCarousels } = createApp(storeData);

	app.$mount('#productDetailPage');
	bottomCarousels.$mount('#pdp-page-bottom-carousel-app');
})();